import dayjs from "dayjs";
import { isInteger } from "formik";
import { getCookie, setCookie } from "../Store/Storage/Cookies";
import { CheckToken } from "../Services/ApiServices";
import { toast } from "react-toastify";
import Forgotpassword from "../Screens/AuthScreen/ForgotPassword/Forgotpassword";
import { env } from "process";

export const TrimObjectValues = (Obj: any) => {
  if (Obj) {
    return Object.keys(Obj).reduce((acc, ele) => {
      if (typeof Obj[ele] === "string") {
        acc = { ...acc, [ele]: Obj[ele]?.trim() };
      } else {
        acc = { ...acc, [ele]: Obj[ele] };
      }
      return acc;
    }, {});
  }
};

export function filterValidObject(obj: any) {
  return Object.entries(obj).reduce((acc: any, [key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});
}

export function filterValidObjectwithEmpty(obj: any) {
  return Object.entries(obj).reduce((acc: any, [key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});
}

export const MomentDateTime = (date: string) => {
  return dayjs(date).format("DD-MM-YYYY HH:mm:ss");
};

export const MomentDate = (date: string) => {
  return dayjs(date).format("DD-MM-YYYY");
};

export const MomentHourAndMinuteTime = (date: string) => {
  return dayjs(date).format("HH:mm A");
};

export async function tokenisValid(token: any) {
  const formData = new FormData();
  formData.append("token", token);
  try {
    let res = await CheckToken(formData);
    if (res.data.status === 1) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    CatchMessage(err);
    return false;
  }
}

export function getCurrentMonthDates() {
  var currentDate = new Date();
  var currentMonth = currentDate.getMonth();
  var currentYear = currentDate.getFullYear();

  // Set the date to the first day of the month
  var startDate = new Date();
  startDate.setDate(1);
  startDate.setMonth(currentMonth);
  startDate.setFullYear(currentYear);

  // Set the date to the last day of the month
  var endDate = new Date();
  endDate.setMonth(currentMonth + 1);
  endDate.setDate(0);
  endDate.setFullYear(currentYear);

  return { start_date: startDate, end_date: endDate };
}

export const CatchMessage = (err: any) => {
  if (err?.response?.data?.detail?.[0]?.msg) {
    toast.error(err.response?.data.detail[0].msg);
  } else if (err?.response?.data?.detail) {
    toast.error(err.response.data.detail);
  } else {
    toast.error("Something went wrong!!");
  }
};

export const avoidletters = (e: any) => {
  if (/[0-9]/.test(e) || e === null) {
    return true;
  } else {
    return false;
  }
};

// export const avoidletters = (letters) => {
//   var ch = String.fromCharCode(letters.which);

//   if (!/[0-9]/.test(ch)) {
//     letters.preventDefault();
//   }
// };

export const ValidinputData = (input: any) => {
  return input.replace(/^[' ']/, "");
};

export const TrimStart = (input: any) => {
  return input.trimStart();
};

// export const AcceptLettersandSpace = (e) => {
//   let result =
//     e.nativeEvent.data !== null
//       ? e.nativeEvent.data.match(/[A-Za-z ]/)
//         ? true
//         : e.nativeEvent.data === null
//       : true;
//   return result;
// };

export const AcceptLettersandSpace = (e: any) => {
  if (/[A-Za-z& ]/.test(e)) {
    return true;
  } else {
    return false;
  }
};

export const AvoidSpecialCharacters = (e: any) => {
  if (/[A-Za-z0-9 ]/.test(e)) {
    return true;
  } else {
    return false;
  }
};

export const AcceptNumbersandLetters = (e: any) => {
  if (/[A-Za-z0-9]/.test(e)) {
    return true;
  } else {
    return false;
  }
};

export const GetValiddata = (data: any) => {
  return data.value.replace(/^ /, "");
};

export const Float_Valildation = (data: any) =>
  (data?.value !== "0" && !isNaN(data?.value)) || data?.value === ""
    ? true
    : false;

export const getNumberWithOneDotOnly = (input: string): string => {
  // Remove all characters except digits and dots
  let cleaned = input.replace(/[^0-9.]/g, "");

  // Allow only the first dot
  const firstDotIndex = cleaned.indexOf(".");
  if (firstDotIndex !== -1) {
    const beforeDot = cleaned.slice(0, firstDotIndex);
    const afterDot = cleaned.slice(firstDotIndex + 1).replace(/\./g, "");

    // Limit to 3 digits after the dot
    cleaned = `${beforeDot}.${afterDot.slice(0, 3)}`;
  }

  return cleaned;
};

export const AvoidSpace = (space: any) => {
  if (space.key === " ") {
    space.preventDefault();
  }
};

export const FormatNumber = (num: string) => {
  // Round to three decimal places
  var roundedNum = parseFloat(num).toFixed(3);

  // Ensure total length is not more than 16 characters
  if (roundedNum.length > 16) {
    // Truncate to fit within 16 characters
    roundedNum = roundedNum.slice(0, 16);
  }

  return roundedNum;
};

export const Acceptnumbersanddot = (letters: any) => {
  var ch = String.fromCharCode(letters.which);
  if (!/[0-9.]/.test(ch)) {
    letters.preventDefault();
  }
};

export const Phone_Number_Validation = (data: any) =>
  isInteger(data.value) || data?.value === "" ? true : false;

export const getValidData = (value: any, type = "text") => {
  if (value !== undefined && value !== null && value !== "") {
    if (type === "text") {
      return value;
    }
  } else {
    return "-";
  }
};
export const numberMaxLength = (e: any, len: any) => {
  if (e.key === "0" || parseInt(e.key)) {
    if (e.target?.value?.length < len) {
    } else {
      e.preventDefault();
    }
  } else if (e.keyCode === 8) {
  } else {
    e.preventDefault();
  }
};

export const JSONtoformdata = (object: any) => {
  const formData = new FormData();
  for (const key in object) {
    if (
      object[key] !== "" &&
      object[key] !== null &&
      object[key] !== undefined
    ) {
      formData.append(
        key,
        typeof object[key] === "string" ? object[key]?.trim() : object[key]
      );
    }
  }

  return formData;
};

export const FilterValuesCheck = (object: any) => {
  // return Object.values(object)
  //   .map((ele: any) => {
  //     return ele !== "" && ele !== null && ele !== undefined ? true : false;
  //   })
  //   .includes(true)
  //   ? false
  //   : true;
  return false;
};

export const JSONtoformdatawithempty = (object: any) => {
  const formData = new FormData();
  for (const key in object) {
    formData.append(
      key,
      object[key] && typeof object[key] === "string"
        ? object[key]?.trim()
        : object[key]
    );
  }

  return formData;
};

export const clearLocalToken = () => {
  setCookie("MconnectEnergyLoginData", null, null);
  window.location.reload();
};

export const getPageCount = (total: any, size: any) => {
  return total / size;
};

// export const handleMultiRouteWithSingleScreen = (router) => {
//   return router?.map((ele) => {
//     return { path: ele, element: <Actioncreateworkdefinition /> };
//   });
// };

export const removeEmptyParams = (query: any) => {
  return query.replace(/[^=&]+=(?:&|$)/g, "");
};

export const removeEmptyQueryString = (queryvalue: any) => {
  return Object.keys(queryvalue)
    .map((filter) => {
      if (queryvalue[filter] || Number.isInteger(queryvalue[filter])) {
        return `${filter}=${queryvalue[filter]}`;
      }
      return null;
    })
    .filter((item) => item)
    .join("&");
};

export const PreventPasting = (e: any) => {
  e.preventDefault();
};

// export const PreventPastingValue = (input) => {
//   window.onload = () => {
//     const myInput = document.getElementById(input);
//     myInput.onpaste = (e) => e.preventDefault();
//     return false;
//   };
// };

export const getHrMinFormat = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes =
    Math.round((totalSeconds % 3600) / 60) >= 60
      ? 59
      : Math.round((totalSeconds % 3600) / 60);
  return hours === 1 && minutes === 1
    ? `1 hr 1 min`
    : hours === 1
    ? `1 hr ${minutes} mins`
    : minutes === 1
    ? `${hours} hr 1 min`
    : `${hours} hr ${minutes} mins`;
};

export const getSeconds = (value: number) => {
  return value === 1 ? `${value} sec` : value > 1 ? `${value} secs` : "-";
};

export const downloadUrl = (url: string) => {
  const inputelement = document.createElement("a");
  inputelement.href = url;
  inputelement.click();
};

export const WattCommonText = () => {
  return <span style={{ fontSize: "12px" }}> (kW)</span>;
};

export const WattText = WattCommonText().props?.children;

export const KWHCommonText = () => {
  return <span style={{ fontSize: "12px" }}> (kWh)</span>;
};

export const KWHText = KWHCommonText().props?.children;

export const TimeConvert = (time: any) => {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
};

export const HandleDeviceId = () => {
  const DevicesSessionCode: any = sessionStorage.getItem("DeviceCode");
  return { deviceId: DevicesSessionCode ? parseInt(DevicesSessionCode) : "" };
};

export const HandleMeterId = () => {
  const MeterSessionCode: any = sessionStorage.getItem("MeterCode");

  return { meter_id: MeterSessionCode ? parseInt(MeterSessionCode) : "" };
};

// export const HandleProjectId = () => {
//   return { project_id: 3 };
// };

// export const HandleBaseURL = () => {
//   const CookieData: any = getCookie("MconnectEnergyLoginData")
//     ? JSON.parse(getCookie("MconnectEnergyLoginData"))
//     : null;

//   return CookieData ? CookieData?.base_url : "";
// };

export const handleEnter = (event: any) => {
  if (event.keyCode === 13) {
    const form = event.target.form;
    const index = Array.prototype.indexOf.call(form, event.target);
    form.elements[index + 1].focus();
    event.preventDefault();
  }
};

export const secondsToMinutesAndSeconds = (millis: any) => {
  var minutes: any = Math.floor(millis / 60);
  var seconds: any = (millis % 60).toFixed(0);
  return (
    (minutes < 10 ? "0" : "") +
    minutes +
    ":" +
    (seconds < 10 ? "0" : "") +
    seconds
  );
};

export const CheckUserType = () => {
  const CookieData: any = getCookie("MconnectEnergyLoginData")
    ? JSON.parse(getCookie("MconnectEnergyLoginData"))
    : null;
  const { userType } = CookieData || {};

  if (userType === 1) {
    return true;
  } else {
    return false;
  }
};

export const CurrentDate = () => {
  return dayjs().format("YYYY-MM-DD 23:59:59");
};

export const SevenDaysBeforeDate = () => {
  const BeforeSevenDays = dayjs()
    .subtract(7, "days")
    .format("YYYY-MM-DD 00:00:00");

  return BeforeSevenDays;
};

export const FirstDateofCurrentmonth = () => {
  var date = new Date();
  var firstDay = dayjs(new Date(date.getFullYear(), date.getMonth(), 1));
  return firstDay;
};

export const LastDateofCurrentmonth = () => {
  var date = new Date();
  var lastDay = dayjs(
    new Date(date.getFullYear(), date.getMonth() + 1, 0)
  ).format("YYYY-MM-DD 00:00:00");

  return lastDay;
};

export const FirstMonthDateofCurrentYear = () => {
  var currentDate = new Date();
  var theFirst = dayjs(new Date(currentDate.getFullYear(), 0, 1)).format(
    "YYYY-MM-DD 23:59:59"
  );

  return theFirst;
};

export const LastMonthDateofCurrentYear = () => {
  var currentDate = new Date();
  var theLast = dayjs(new Date(currentDate.getFullYear(), 11, 31)).format(
    "YYYY-MM-DD 00:00:00"
  );

  return theLast;
};
export const handleGetValidFormDataValue = (data: any) => {
  const checkValue = [
    null,
    undefined,
    "",
    "false",
    false,
    "undefined",
    undefined,
  ];
  const newFormData = new FormData();
  let hasValidData = false;

  data.forEach((value: any, key: any) => {
    if (!checkValue.includes(value) && value) {
      newFormData.append(key, value);
      hasValidData = true; // Mark that valid data exists
    }
  });

  return hasValidData ? newFormData : undefined; // Return undefined if no valid data
};
